// extracted by mini-css-extract-plugin
export var bubble = "_41-0";
export var container = "_41-3";
export var contrastBorder = "_41-4";
export var greyOut = "_41-2";
export var initialsWrapper = "_41-1";
export var large = "_41-9";
export var medium = "_41-8";
export var mediumSmall = "_41-7";
export var mediumSmallMedium = "_41-c";
export var micro = "_41-5";
export var small = "_41-6";
export var tiny = "_41-b";
export var xTiny = "_41-a";